export default __webpack_public_path__ + "static/media/bild.fea99dd9.png";